import { gsd, optimizePeaks, joinBroadPeaks } from 'ml-gsd';
import { xyExtract, xNoiseSanPlot, xAbsoluteMedian, } from 'ml-spectra-processing';
import { convertWidthToHz } from '../peaks/util/convertWidthToHz';
export function xyAutoPeaksPicking(data, options) {
    const { from, to, frequency, noiseLevel, thresholdFactor = 3, minMaxRatio = 0.05, broadRatio = 0.00025, useSanPlot = false, smoothY = true, optimize = false, factorLimits = 4, realTopDetection = true, shape = { kind: 'gaussian' }, optimization = { kind: 'lm' }, broadWidth = 0.25, sgOptions = {}, direction = 'positive', } = options;
    const { windowSize = 9, polynomial = 3 } = sgOptions;
    if (data.x.length < windowSize)
        return [];
    if (from !== undefined && to !== undefined) {
        data = xyExtract(data, { zones: [{ from, to }] });
    }
    const cutOff = getCutOff(data.y, { noiseLevel, useSanPlot, thresholdFactor });
    let getPeakOptions = {
        shape,
        frequency,
        broadWidth,
        optimize,
        factorLimits,
        maxCriteria: true,
        sgOptions: { windowSize, polynomial },
        minMaxRatio,
        broadRatio,
        noiseLevel: cutOff.positive,
        smoothY,
        optimization,
        realTopDetection,
    };
    switch (direction) {
        case 'positive': {
            return getPeakList(data, getPeakOptions);
        }
        case 'negative': {
            return getNegativePeaks(data, cutOff, getPeakOptions);
        }
        case 'both': {
            return [
                ...getPeakList(data, getPeakOptions),
                ...getNegativePeaks(data, cutOff, getPeakOptions),
            ];
        }
        default: {
            const unHandled = direction;
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            throw Error(`Unknown distribution ${unHandled}`);
        }
    }
}
function getNegativePeaks(data, cutOff, getPeakOptions) {
    getPeakOptions.noiseLevel = cutOff.negative;
    getPeakOptions.maxCriteria = false;
    return getPeakList(data, getPeakOptions);
}
function getPeakList(data, options) {
    const { shape, frequency, broadWidth, optimize, maxCriteria, factorLimits, sgOptions, minMaxRatio, broadRatio, noiseLevel, smoothY, optimization, realTopDetection, } = options;
    let peakList = gsd(data, {
        shape,
        sgOptions,
        maxCriteria,
        minMaxRatio,
        noiseLevel,
        smoothY,
        realTopDetection,
    });
    if (broadWidth) {
        peakList = joinBroadPeaks(peakList, {
            broadRatio,
            broadWidth,
            shape,
            optimization,
        });
    }
    if (optimize) {
        return optimizePeaks(data, peakList, {
            shape,
            factorLimits,
            optimization,
        });
    }
    return convertWidthToHz(peakList, frequency);
}
function getCutOff(data, options) {
    const { noiseLevel, useSanPlot, thresholdFactor } = options;
    const formatResult = (noiseLevel) => typeof noiseLevel === 'number'
        ? { positive: noiseLevel, negative: -noiseLevel }
        : noiseLevel;
    if (noiseLevel) {
        return formatResult(noiseLevel);
    }
    else {
        return useSanPlot
            ? xNoiseSanPlot(data, { factorStd: thresholdFactor })
            : formatResult(xAbsoluteMedian(data) * thresholdFactor);
    }
}
//# sourceMappingURL=xyAutoPeaksPicking.js.map